import React, { Component, Fragment } from "react";
import SelectComponent from "../Select";
import { DateUtils } from "../../utils";
import DatePickerComponent from "../../components/Datepicker";
import InputMask from "react-input-mask";
import { SpaceBox } from "../../components/Space";
import { isEmpty, validatePhone, validateEmail } from '../../utils/validator';
import moment from 'moment';
import Crypter from '../../utils/crypter';
import EmailService from '../../service/email';
import alert from "../../utils/alert";

export default class ContactFormComponent extends Component {

  today = new Date(DateUtils.getCurrentTh("YYYY-MM-DD"));
  max3Month = new Date(moment(this.today).add(3, 'months').format('YYYY-MM-DD'));

  onSubmit = async () => {
    const {
      productName,
      cName,
      cLastName,
      cMobile,
      cEmail,
      cDetail,
      cDate,
      cTime,
      onSubmit,
    } = this.props;

    // console.log(crpyter.encode({ user_id: 23292, phone: '+66878080921' }));

    // console.log(
    //   cName,
    //   cLastName,
    //   cMobile,
    //   cEmail,
    //   cDetail,
    //   cDate,
    //   cTime.value)

    const html = cDetail.replace(/<script.*>.*<\/script>/ims, "");
    try {
      alert.showLoading();
      const res = await EmailService.sendEmailContact({
        requestPayload: Crypter.encode({
          product: productName,
          full_name: cName + " " + cLastName,
          phone: cMobile,
          email: cEmail,
          detail: html,
          date: moment(cDate).format('DD/MM/YYYY') + " " + cTime.value,
        })
      })
      if (res && res.success) {
        alert.alertWithTitle("ส่งข้อมูลสำเร็จ", "ระบบได้รับข้อมูลการติดต่อกลับของท่านเรียบร้อยแล้ว", "success");

      } else {
        if (res.msg = 'FLOODING') {
          alert.alertWithTitle("ดำเนินการไม่สำเร็จ", "ท่านได้ทำการส่งข้อความถึงเจ้าหน้าที่แล้ว กรุณารอ 15 นาทีก่อนทำรายการใหม่อีกครั้ง", "warning");
        } else {
          alert.alertWithTitle("ติดต่อเจ้าหน้าที่", "เกิดข้อผิดพลาดกรุณาติดต่อเจ้าหน้าที่ Call Center 148", "warning");
        }
      }
      alert.hideLoading();
    }
    catch {
      alert.hideLoading();
      alert.alertWithTitle("ติดต่อเจ้าหน้าที่", "เกิดข้อผิดพลาดกรุณาติดต่อเจ้าหน้าที่ Call Center 148", "warning");
    }
    if (onSubmit) {
      onSubmit();
    }
  }

  formValidate() {
    const {
      cName,
      cLastName,
      cMobile,
      cReason,
      cEmail,
      cDetail,
      cDate,
      cTime,
    } = this.props;

    return isEmpty(cName) ||
      isEmpty(cLastName) ||
      isEmpty(cMobile) ||
      !validatePhone(cMobile) ||
      isEmpty(cEmail) ||
      isEmpty(cReason) ||
      !validateEmail(cEmail) ||
      isEmpty(cDetail) ||
      isEmpty(cDate) ||
      isEmpty(cTime);
  }

  render() {
    const {
      time,
      reason,
      cName,
      cLastName,
      cMobile,
      cEmail,
      cReason,
      cDetail,
      cDate,
      cTime,
      options,
      onChange
    } = this.props;
    const disabledSubmit = this.formValidate();

    const {
      cNameKey = "cName",
      cLastNameKey = "cLastName",
      cMobileKey = "cMobile",
      cEmailKey = "cEmail",
      cReasonKey = "cReason",
      cDetailKey = "cDetail",
      cDateKey = "cDate",
      cTimeKey = "cTime"
    } = options || {};

    return (
      <Fragment>
        <div className="form-group d-flex mb-0">
          <div className="form-group w-50">
            <label>ชื่อ</label>
            <InputMask
              mask="*******************************************************"
              maskChar=""
              formatChars={{
                "*": "[a-zA-Z\u0E00-\u0E7Fก-ฮ]"
              }}
              permanents={[2, 5]}
              type="text"
              value={cName}
              onChange={e =>
                onChange({ name: e.target.name, value: e.target.value })
              }
            >
              {inputProps => (
                <input
                  {...inputProps}
                  className="form-control mt-2"
                  placeholder="ชื่อ"
                  name={cNameKey}
                />
              )}
            </InputMask>
          </div>
          <SpaceBox />
          <div className="form-group w-50">
            <label>นามสกุล</label>
            <InputMask
              mask="*******************************************************"
              maskChar=""
              formatChars={{
                "*": "[a-zA-Z\u0E00-\u0E7Fก-ฮ]"
              }}
              permanents={[2, 5]}
              type="text"
              value={cLastName}
              onChange={e =>
                onChange({ name: e.target.name, value: e.target.value })
              }
            >
              {inputProps => (
                <input
                  {...inputProps}
                  className="form-control mt-2"
                  placeholder="นามสกุล"
                  name={cLastNameKey}
                />
              )}
            </InputMask>
          </div>
        </div>
        <div className="form-group">
          <label>เบอร์ติดต่อกลับ</label>
          <InputMask
            mask="9999999999"
            type="tel"
            value={cMobile}
            onChange={e =>
              onChange({ name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                {...inputProps}
                className="form-control"
                placeholder="เบอร์โทรศัพท์"
                name={cMobileKey}
              />
            )}
          </InputMask>
        </div>
        <div className="form-group">
          <label>อีเมล</label>
          <input
            type="text"
            className="form-control"
            placeholder="name@email.com"
            maxLength={255}
            name={cEmailKey}
            value={cEmail}
            onChange={e =>
              onChange({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label>กรุณาเลือกเรื่องที่ต้องการติดต่อ</label>
          <SelectComponent
            placeholder="กรุณาเลือกเรื่องที่ต้องการติดต่อ"
            options={reason}
            selected={cReason}
            onChange={selected =>
              onChange({ name: cReasonKey, value: selected })
            }
          />
        </div>
        <div className="form-group">
          <label>รายละเอียดที่ต้องการให้ติดต่อกลับ</label>
          <textarea
            type="text"
            className="form-control detail-box"
            placeholder="ข้อความ"
            name={cDetailKey}
            maxLength="3000"
            value={cDetail}
            onChange={e =>
              onChange({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label>วันเวลาที่ต้องการให้ติดต่อกลับ</label>
          <div className="d-flex">
            <DatePickerComponent
              minDate={this.today}
              maxDate={this.max3Month}
              selected={cDate ? new Date(cDate) : ""}
              placeholderText="วันที่"
              onChange={date => onChange({ name: cDateKey, value: date })}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              popperPlacement="top-start"
            />
            <SpaceBox />
            <div className="w-50">
              <SelectComponent
                placeholder="ช่วงเวลา"
                options={time}
                selected={cTime}
                onChange={selected =>
                  onChange({ name: cTimeKey, value: selected })
                }
              />
            </div>
          </div>
        </div>

        <SpaceBox h="24px" />
        <button
          disabled={disabledSubmit}
          className="form-control btn-primary m-auto" style={{ width: '80%' }}
          onClick={this.onSubmit}
        >
          ส่งข้อมูล
        </button>
      </Fragment>
    );
  }
}
